import instance from "./axios-instance";

/**
 * 获取最近的 Sitemap 生成任务。
 * @returns {Promise<any>} 任务列表响应
 */
export const getSitemapJobs = async () => {
  const { data } = await instance.get("/api/v1/admin/sitemaps");
  return data;
};

/**
 * 创建 Sitemap 生成任务。
 * @param {{ baseUrl: string }} payload 生成配置
 * @returns {Promise<any>} 任务响应
 */
export const generateSitemap = async (payload) => {
  const { data } = await instance.post("/api/v1/admin/sitemaps", payload);
  return data;
};

/**
 * 重试失败的 Sitemap 任务。
 * @param {string} jobId 任务 ID
 * @returns {Promise<any>} 任务响应
 */
export const retrySitemapJob = async (jobId) => {
  const { data } = await instance.post(`/api/v1/admin/sitemaps/${jobId}/retry`);
  return data;
};

/**
 * 生成 Sitemap 文件下载地址。
 * @param {string} jobId 任务 ID
 * @param {string} fileName 文件名
 * @returns {string} 下载地址
 */
export const getSitemapDownloadUrl = (jobId, fileName) =>
  instance.getUri({
    url: `/api/v1/admin/sitemaps/${jobId}/files/${fileName}`,
  });
